module.exports = {
	Polygon: require("./Polygon").default,
}